/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm, imageTypes, replacePXinStringWithEM } from 'utils/styles';



// ===================== ANIMATION : TOP : PROGRESS BAR / SHARE SET ICONS ===================== //
const aniFrameCountdownBarResult = {
    // ~~~~~~~~~~~~~~~~~~~~~ RESULT STATE ~~~~~~~~~~~~~~~~~~~~~ //
    '& .progressbar.type-frame': {
        animationName: 'fadeOutUp',
        animationDelay: '.6s',
        animationDuration: '.3s',
        animationFillMode: 'forwards'
    }
};



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export { aniFrameCountdownBarResult };